module.exports = __webpack_public_path__ + "img/sales_scraping.49ac5007.gif";